import { SVGProps } from 'react';

export const LogoutIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg data-icon width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.26939 13.3711C3.26939 13.7183 2.98761 13.9999 2.64049 14H0.627791C0.280777 13.9997 -0.000138283 13.7182 -0.000138283 13.3711V0.628906C-0.000138283 0.281661 0.281523 0 0.628768 0H2.64049C2.98761 0.000137023 3.26939 0.281746 3.26939 0.628906C3.2693 0.975991 2.98756 1.25768 2.64049 1.25781H1.2567V12.7422H2.64049C2.98757 12.7423 3.26931 13.024 3.26939 13.3711ZM13.9471 7.01855C13.9543 7.18815 13.8958 7.36067 13.7665 7.49023L9.62877 11.627C9.38323 11.8722 8.98554 11.8723 8.7401 11.627C8.49457 11.3814 8.49456 10.9828 8.7401 10.7373L11.8495 7.62793H3.97838C3.63125 7.62793 3.34967 7.34708 3.34947 7C3.34966 6.65292 3.63125 6.37109 3.97838 6.37109H11.8124L8.7401 3.29883C8.49457 3.05329 8.49456 2.65471 8.7401 2.40918C8.98558 2.16409 9.38333 2.16402 9.62877 2.40918L13.7665 6.5459C13.8962 6.67568 13.9545 6.84859 13.9471 7.01855Z"
        fill="currentColor"
      />
    </svg>
  );
};
